import styled from 'styled-components'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../../../styles/theme'

export const StakeholderCTAItem = styled.div<{ $accentColor: string; $isLoading: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING.sm} ${SPACING.md};
  border-top: 1px solid var(--color-border);
  background: var(--color-bg-secondary);
  opacity: ${(props) => (props.$isLoading ? 0.7 : 1)};

  &:first-child {
    border-top: none;
  }
`

export const StakeholderCTAInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
  min-width: 0;
  flex: 1;
`

export const StakeholderCTADetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const StakeholderCTAName = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StakeholderCTARole = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-tertiary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const AskFeedbackButton = styled.button<{ $accentColor: string; $isLoading: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 3px 6px;
  background: var(--color-node-bg);
  border: none;
  border-radius: 4px;
  color: var(--color-text-secondary);
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  cursor: ${(props) => (props.$isLoading ? 'not-allowed' : 'pointer')};
  transition: all 0.15s ease;
  white-space: nowrap;
  pointer-events: ${(props) => (props.$isLoading ? 'none' : 'auto')};
  box-shadow: var(--shadow-card);
  line-height: 1;

  &:hover {
    background: var(--color-bg-hover);
    transform: ${(props) => (props.$isLoading ? 'none' : 'scale(1.02)')};
    box-shadow: var(--shadow-card-hover);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
